/* eslint-disable no-nested-ternary */
/* eslint-disable no-throw-literal */
import type { AxiosRequestConfig } from "axios";
import axios from "axios";
import { localStorageKeys } from "config/localStorageKeys";

export const fetchRequest = async (input: string, init: AxiosRequestConfig) => {
  try {
    const domain = localStorage.getItem(localStorageKeys.domainUrl);
    const response = await axios({
      url: `${domain}/${input}`,
      ...init,
      headers: {
        "Content-Type": "application/json",
        ...init.headers
      }
    });

    return Promise.resolve(response);
  } catch (err: any) {
    const domain = localStorage.getItem(localStorageKeys.domainUrl);
    console.error(`fetchRequest err ${domain}${input}`, err?.response);

    return Promise.reject({
      partErr: err?.response?.data,
      fullErr: err
    });
  }
};
